import { deletePersonalKeys } from '@faceup/crypto'
import * as Sentry from '@sentry/react'

export const AUTH_TOKEN_NAME = 'jwt'

class Auth {
  public static logout = () => {
    Sentry.setUser(null)

    localStorage.removeItem(AUTH_TOKEN_NAME)
    sessionStorage.removeItem(AUTH_TOKEN_NAME)
    deletePersonalKeys()
  }

  public static setJwt = ({ jwt, persistent = false }: { jwt: string; persistent?: boolean }) => {
    Sentry.setUser({ id: Auth.getUserIdFromJWT(jwt) })

    if (persistent) {
      localStorage.setItem(AUTH_TOKEN_NAME, jwt)
    } else {
      sessionStorage.setItem(AUTH_TOKEN_NAME, jwt)
    }
  }

  public static getJwt = () => {
    const localToken = localStorage.getItem(AUTH_TOKEN_NAME)
    if (localToken) {
      Sentry.setUser({ id: Auth.getUserIdFromJWT(localToken) })
      return localToken
    }

    const sessionToken = sessionStorage.getItem(AUTH_TOKEN_NAME)
    if (sessionToken) {
      Sentry.setUser({ id: Auth.getUserIdFromJWT(sessionToken) })
      return sessionToken
    }

    Sentry.setUser(null)
    return null
  }

  public static isAuthenticated = () => Boolean(Auth.getJwt())

  public static isRemembered = () => Boolean(localStorage.getItem(AUTH_TOKEN_NAME))

  public static getUserIdFromJWT = (jwt: string) => {
    const payload = (jwt.split('.') ?? [])[1]
    if (!payload) {
      return ''
    }

    const { id, userType } = JSON.parse(atob(payload))

    return `${userType ?? 'FuAdmin'}:${id}`
  }
}

export default Auth
